import { render, staticRenderFns } from "./SellCreditDocumentList.vue?vue&type=template&id=64adf32e&"
import script from "./SellCreditDocumentList.vue?vue&type=script&lang=js&"
export * from "./SellCreditDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports